'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('./utils'),
    difference = _require.difference;

var EventEmitter = require('events');

var DEFAULT_OPTIONS = {
  start: true,
  pollInterval: 1000
};

var IpfsPubsubPeerMonitor = /*#__PURE__*/function (_EventEmitter) {
  _inherits(IpfsPubsubPeerMonitor, _EventEmitter);

  var _super = _createSuper(IpfsPubsubPeerMonitor);

  function IpfsPubsubPeerMonitor(ipfsPubsub, topic, options) {
    var _this;

    _classCallCheck(this, IpfsPubsubPeerMonitor);

    _this = _super.call(this);
    _this._pubsub = ipfsPubsub;
    _this._topic = topic;
    _this._options = Object.assign({}, DEFAULT_OPTIONS, options);
    _this._peers = [];
    _this._interval = null;
    if (_this._options.start) _this.start();
    return _this;
  }

  _createClass(IpfsPubsubPeerMonitor, [{
    key: "started",
    get: function get() {
      return this._interval !== null;
    },
    set: function set(val) {
      throw new Error("'started' is read-only");
    }
  }, {
    key: "start",
    value: function start() {
      if (this._interval) this.stop();
      this._interval = setInterval(this._pollPeers.bind(this), this._options.pollInterval);

      this._pollPeers();
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this._interval);
      this._interval = null;
      this.removeAllListeners('error');
      this.removeAllListeners('join');
      this.removeAllListeners('leave');
    }
  }, {
    key: "getPeers",
    value: function () {
      var _getPeers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._pubsub.peers(this._topic);

              case 2:
                this._peers = _context.sent;
                return _context.abrupt("return", this._peers.slice());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPeers() {
        return _getPeers.apply(this, arguments);
      }

      return getPeers;
    }()
  }, {
    key: "hasPeer",
    value: function hasPeer(peer) {
      return this._peers.includes(peer);
    }
  }, {
    key: "_pollPeers",
    value: function () {
      var _pollPeers2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var peers;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this._pubsub.peers(this._topic);

              case 3:
                peers = _context2.sent;

                IpfsPubsubPeerMonitor._emitJoinsAndLeaves(new Set(this._peers), new Set(peers), this);

                this._peers = peers;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                clearInterval(this._interval);
                this.emit('error', _context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function _pollPeers() {
        return _pollPeers2.apply(this, arguments);
      }

      return _pollPeers;
    }()
  }], [{
    key: "_emitJoinsAndLeaves",
    value: function _emitJoinsAndLeaves(oldValues, newValues, events) {
      var emitJoin = function emitJoin(addedPeer) {
        return events.emit('join', addedPeer);
      };

      var emitLeave = function emitLeave(removedPeer) {
        return events.emit('leave', removedPeer);
      };

      difference(newValues, oldValues).forEach(emitJoin);
      difference(oldValues, newValues).forEach(emitLeave);
    }
  }]);

  return IpfsPubsubPeerMonitor;
}(EventEmitter);

module.exports = IpfsPubsubPeerMonitor;